import { render, staticRenderFns } from "./New.vue?vue&type=template&id=96cd0562&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/apps/invoice.css?vue&type=style&index=0&id=96cd0562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cd0562",
  null
  
)

export default component.exports